<div class="container mt-5">
  <div class="row justify-content-center">
    <div class="col-12 col-lg-8">

      <div class="card">
        <div class="card-body text-center">

          <div class="mb-4">
            <i class="fas fa-times-circle text-danger fa-4x"></i>
          </div>

          <h2 class="text-danger">
            {{ 'PAYMENT_FAILED' | translate }}</h2>

          <hr>

          <p>
            {{ 'WE_WERE_UNABLE_TO_VERIFY_YOUR_PAYMENT' | translate }}</p>

          <p>
            {{ 'IF_YOUR_CARD_WAS_CHARGED_PLEASE_CONTACT_THE_CHURCH_ADMINISTRATOR' | translate }}</p>

          <p>
            {{ 'YOU_MAY_ALSO_RETURN_TO_THE_FORM_AND_TRY_AGAIN' | translate }}</p>

          <!-- <button
            class="btn btn-primary mt-3"
            onclick="history.back()">
            Return
          </button> -->

        </div>
      </div>

    </div>
  </div>
</div>